/**
 * THIS FILE IS AUTO-GENERATED by GraphQL Code Generator.
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * Source: module-auth/src/api/gql/identity.front.graphql
 * Schema: Federation Gateway (Auth Service)
 *
 * Run codegen:
 *   GRAPHQL_API_URL=<gateway-url> npx graphql-codegen --config codegen.yml
 */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
const defaultOptions = {} as const;

// ─── Scalar Types ─────────────────────────────────────────────────────────────

export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
};

// ─── Enum Types ───────────────────────────────────────────────────────────────

/** Re-export NotificationChannel from front.graphql — shared enum */
export { NotificationChannel } from './front.graphql';

// ─── Object Types ─────────────────────────────────────────────────────────────

export type IdentityOtpChallengeResponse = {
    __typename?: 'IdentityOtpChallengeResponse';
    success: Scalars['Boolean']['output'];
    session?: Maybe<Scalars['String']['output']>;
    challengeName?: Maybe<Scalars['String']['output']>;
    isNewUser?: Maybe<Scalars['Boolean']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    errorCode?: Maybe<Scalars['String']['output']>;
};

export type IdentityAuthResult = {
    __typename?: 'IdentityAuthResult';
    success: Scalars['Boolean']['output'];
    idpAccessToken?: Maybe<Scalars['String']['output']>;
    idpIdToken?: Maybe<Scalars['String']['output']>;
    idpRefreshToken?: Maybe<Scalars['String']['output']>;
    expiresIn?: Maybe<Scalars['Int']['output']>;
    tokenType?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    errorCode?: Maybe<Scalars['String']['output']>;
    /** New challenge session returned on wrong OTP — client uses it for retry */
    session?: Maybe<Scalars['String']['output']>;
};

export type IdentitySignUpResult = {
    __typename?: 'IdentitySignUpResult';
    success: Scalars['Boolean']['output'];
    cognitoSub?: Maybe<Scalars['String']['output']>;
    commerceAccessToken?: Maybe<Scalars['String']['output']>;
    commerceRefreshToken?: Maybe<Scalars['String']['output']>;
    commerceExpiresIn?: Maybe<Scalars['Int']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    errorCode?: Maybe<Scalars['String']['output']>;
};

// ─── Operation Types ──────────────────────────────────────────────────────────

export type InitiateIdentityOtpChallengeMutationVariables = Exact<{
    phoneNumber: Scalars['String']['input'];
    notificationChannel?: InputMaybe<Scalars['String']['input']>;
}>;

export type InitiateIdentityOtpChallengeMutation = {
    __typename?: 'Mutation';
    initiateIdentityOtpChallenge: {
        __typename?: 'IdentityOtpChallengeResponse';
        success: boolean;
        session?: string | null;
        challengeName?: string | null;
        isNewUser?: boolean | null;
        message?: string | null;
        errorCode?: string | null;
    };
};

export type VerifyIdentityOtpChallengeMutationVariables = Exact<{
    session: Scalars['String']['input'];
    phoneNumber: Scalars['String']['input'];
    otp: Scalars['String']['input'];
}>;

export type VerifyIdentityOtpChallengeMutation = {
    __typename?: 'Mutation';
    verifyIdentityOtpChallenge: {
        __typename?: 'IdentityAuthResult';
        success: boolean;
        idpAccessToken?: string | null;
        idpIdToken?: string | null;
        idpRefreshToken?: string | null;
        expiresIn?: number | null;
        tokenType?: string | null;
        message?: string | null;
        errorCode?: string | null;
        session?: string | null;
    };
};

export type IdentitySignUpMutationVariables = Exact<{
    phoneNumber: Scalars['String']['input'];
    email: Scalars['String']['input'];
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
    referralCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type IdentitySignUpMutation = {
    __typename?: 'Mutation';
    identitySignUp: {
        __typename?: 'IdentitySignUpResult';
        success: boolean;
        cognitoSub?: string | null;
        commerceAccessToken?: string | null;
        commerceRefreshToken?: string | null;
        commerceExpiresIn?: number | null;
        message?: string | null;
        errorCode?: string | null;
    };
};

// ─── Document Nodes ───────────────────────────────────────────────────────────

export const InitiateIdentityOtpChallengeDocument = gql`
    mutation InitiateIdentityOtpChallenge($phoneNumber: String!, $notificationChannel: NotificationChannel) {
        initiateIdentityOtpChallenge(phoneNumber: $phoneNumber, notificationChannel: $notificationChannel) {
            success
            session
            challengeName
            isNewUser
            message
            errorCode
        }
    }
`;
export type InitiateIdentityOtpChallengeMutationFn = Apollo.MutationFunction<
    InitiateIdentityOtpChallengeMutation,
    InitiateIdentityOtpChallengeMutationVariables
>;

export function useInitiateIdentityOtpChallengeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        InitiateIdentityOtpChallengeMutation,
        InitiateIdentityOtpChallengeMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<InitiateIdentityOtpChallengeMutation, InitiateIdentityOtpChallengeMutationVariables>(
        InitiateIdentityOtpChallengeDocument,
        options
    );
}
export type InitiateIdentityOtpChallengeMutationHookResult = ReturnType<typeof useInitiateIdentityOtpChallengeMutation>;
export type InitiateIdentityOtpChallengeMutationResult = Apollo.MutationResult<InitiateIdentityOtpChallengeMutation>;
export type InitiateIdentityOtpChallengeMutationOptions = Apollo.BaseMutationOptions<
    InitiateIdentityOtpChallengeMutation,
    InitiateIdentityOtpChallengeMutationVariables
>;

export const VerifyIdentityOtpChallengeDocument = gql`
    mutation VerifyIdentityOtpChallenge($session: String!, $phoneNumber: String!, $otp: String!) {
        verifyIdentityOtpChallenge(session: $session, phoneNumber: $phoneNumber, otp: $otp) {
            success
            idpAccessToken
            idpIdToken
            idpRefreshToken
            expiresIn
            tokenType
            message
            errorCode
            session
        }
    }
`;
export type VerifyIdentityOtpChallengeMutationFn = Apollo.MutationFunction<
    VerifyIdentityOtpChallengeMutation,
    VerifyIdentityOtpChallengeMutationVariables
>;

export function useVerifyIdentityOtpChallengeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        VerifyIdentityOtpChallengeMutation,
        VerifyIdentityOtpChallengeMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<VerifyIdentityOtpChallengeMutation, VerifyIdentityOtpChallengeMutationVariables>(
        VerifyIdentityOtpChallengeDocument,
        options
    );
}
export type VerifyIdentityOtpChallengeMutationHookResult = ReturnType<typeof useVerifyIdentityOtpChallengeMutation>;
export type VerifyIdentityOtpChallengeMutationResult = Apollo.MutationResult<VerifyIdentityOtpChallengeMutation>;
export type VerifyIdentityOtpChallengeMutationOptions = Apollo.BaseMutationOptions<
    VerifyIdentityOtpChallengeMutation,
    VerifyIdentityOtpChallengeMutationVariables
>;
export const IdentitySignUpDocument = gql`
    mutation IdentitySignUp(
        $phoneNumber: String!
        $email: String!
        $firstName: String!
        $lastName: String!
        $referralCode: String
    ) {
        identitySignUp(
            phoneNumber: $phoneNumber
            email: $email
            firstName: $firstName
            lastName: $lastName
            referralCode: $referralCode
        ) {
            success
            cognitoSub
            commerceAccessToken
            commerceRefreshToken
            commerceExpiresIn
            message
            errorCode
        }
    }
`;
export type IdentitySignUpMutationFn = Apollo.MutationFunction<IdentitySignUpMutation, IdentitySignUpMutationVariables>;

export function useIdentitySignUpMutation(
    baseOptions?: Apollo.MutationHookOptions<IdentitySignUpMutation, IdentitySignUpMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<IdentitySignUpMutation, IdentitySignUpMutationVariables>(IdentitySignUpDocument, options);
}
export type IdentitySignUpMutationHookResult = ReturnType<typeof useIdentitySignUpMutation>;
export type IdentitySignUpMutationResult = Apollo.MutationResult<IdentitySignUpMutation>;
export type IdentitySignUpMutationOptions = Apollo.BaseMutationOptions<
    IdentitySignUpMutation,
    IdentitySignUpMutationVariables
>;
